import { Alert, Button, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import type { TrackingValidationResponse } from '@repo/sdk'

import { getTrackingValidationAlertType } from './useTrackingValidation'

interface TrackingValidationPanelProps {
  result: TrackingValidationResponse | null
  isValidating: boolean
  onValidate: () => void
  testIdPrefix: string
}

/** "Validate tracking number" button plus the inline result alert, shared by ship/change modals. */
export function TrackingValidationPanel({
  result,
  isValidating,
  onValidate,
  testIdPrefix,
}: TrackingValidationPanelProps) {
  const { t } = useTranslation()

  const lastEvent = result?.tracking?.lastEventDescription
    ? `${result.tracking.lastEventDescription}${
        result.tracking.lastEventLocation ? ` (${result.tracking.lastEventLocation})` : ''
      }`
    : undefined

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Button
        onClick={onValidate}
        loading={isValidating}
        data-testid={`${testIdPrefix}-validate-tracking-btn`}
      >
        {t('pages.orders.trackingValidation.button')}
      </Button>
      {result && (
        <Alert
          showIcon
          type={getTrackingValidationAlertType(result.status)}
          message={t(`pages.orders.trackingValidation.status.${result.status}`)}
          description={lastEvent}
          data-testid={`${testIdPrefix}-validation-alert`}
        />
      )}
    </Space>
  )
}
